import Promise from 'promise';
import loadScript from './loadScript';

var _mqqPromise = null;
//惰性加载
export default function () {
  if (!_mqqPromise) {
    _mqqPromise = new Promise(resolve => {
      loadScript('//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152', () => {
        resolve();
      });
    });
  }
  return _mqqPromise;
}
